import { useContext } from "react";
import { ToastContext } from "./Context";

export const useToast = () => {
  const { addToast } = useContext(ToastContext);
  return { addToast };
};
